export default __webpack_public_path__ + "static/media/aliro.eb51ab7d.png";